import { h } from '@/lib/dom';
import { flagToStatus, statusLabel } from '@/lib/format';

export type MarkerStatus = 'high' | 'low' | 'norm' | 'borderline' | 'unknown' | 'stale';

export interface MarkerBadgeProps {
  flag?: string | null;
  status?: MarkerStatus;
  withLabel?: boolean;
  ariaLabelPrefix?: string;
}

export function MarkerBadge(props: MarkerBadgeProps): HTMLElement {
  const status = props.status ?? flagToStatus(props.flag);
  const label = statusLabel(status);
  const shortLetter = status === 'high' ? 'H' : status === 'low' ? 'L' : status === 'borderline' ? '!' : '';
  const prefix = props.ariaLabelPrefix ?? '';
  return h(
    'span',
    {
      class: `marker-badge status-${status}`,
      aria: { label: prefix ? `${prefix}: ${label}` : label },
    },
    [
      h('span', { class: 'dot', 'aria-hidden': 'true' }),
      shortLetter && (props.withLabel ?? false) === false
        ? h('span', { 'aria-hidden': 'true' }, shortLetter)
        : null,
      props.withLabel ? h('span', null, label) : null,
    ],
  );
}
